import Image from 'next/image';
import React, { useEffect, useRef } from 'react';

export enum EModalType {
  SUCCESS = 'success',
  ERROR = 'error'
}

interface IProps {
  toggleModal: () => void;
  modalType: EModalType;
  buttonText: string;
  message: string;
  buttonHandler: () => void;
  modalIconLink?: string;
}

const NotificationModal = ({
  toggleModal,
  modalType,
  buttonText,
  message,
  buttonHandler,
  modalIconLink
}: IProps) => {
  /* It handles outside clicks to close the modal. */
  const modalContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        modalContainerRef.current &&
        !modalContainerRef.current.contains(event.target as Node)
      ) {
        toggleModal();
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [toggleModal]);

  const successIconLink = `https://res.cloudinary.com/see-sight-tours/image/upload/v1707985604/icons-website/q5eiydpc2kpn3ozfrbdj.png`;

  const errorIconLink = `https://res.cloudinary.com/see-sight-tours/image/upload/v1707985604/icons-website/d88qspxhyovl6lc5xkts.png`;

  {
    /* Modal Wrapper z-index should be 1150 or in between 1100 and 1200 */
  }

  return (
    <>
      <div className="fixed inset-0 z-[1150] bg-gray-800 bg-opacity-50 flex items-center justify-center">
        <div
          ref={modalContainerRef}
          className={`${
            modalType == EModalType.SUCCESS ? `bg-green` : `bg-primary`
          }  rounded-2xl flex flex-col text-center pt-3 mx-2 w-[90%] md:w-[65%] lg:w-[50%] xl:w-[40%] 2xl:w-[30%]`}
          style={{
            background: modalType == EModalType.SUCCESS ? '#00B74A' : '#1F2C5B'
          }}
        >
          <div className="bg-white rounded-2xl flex flex-col text-center p-5 w-full items-center">
            <div className="flex flex-col gap-6 items-center">
              <Image
                src={
                  modalIconLink
                    ? modalIconLink
                    : modalType == EModalType.SUCCESS
                    ? successIconLink
                    : errorIconLink
                }
                alt="notification icon"
                width={58}
                height={58}
                className="mt-3"
              />
              <div className="flex  flex-col gap-4 items-center">
                <p className="text-xl font-semibold">
                  {modalType == EModalType.SUCCESS ? 'Success!' : 'Error :('}
                </p>
                <p className="text-lg font-normal text-gray82">{message}</p>
                <button
                  className={`hover:bg-[#2E3D7A] active:bg-[#2E3D7A] ${
                    modalType == EModalType.SUCCESS ? `bg-green` : `bg-primary`
                  } text-white text-base rounded-full w-36 h-12`}
                  onClick={buttonHandler}
                  style={{
                    background:
                      modalType == EModalType.SUCCESS ? '#00B74A' : 'bg-primary'
                  }}
                >
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationModal;
